import { Component, inject, Input } from '@angular/core';
import { Router } from '@angular/router';
import {
  GcButtonComponent,
  GcIconComponent,
  GcTextComponent,
  IpoTranslatePipe,
} from '@ip-only/front-end-library';

export type SigningSummaryErrorType =
  | 'NO_REPORT'
  | 'SIGNING_NOT_AVAILABLE'
  | 'UNKNOWN_ERROR';

@Component({
  selector: 'app-error-screen-signing-summary',
  standalone: true,
  imports: [
    GcTextComponent,
    GcIconComponent,
    GcButtonComponent,
    IpoTranslatePipe,
  ],
  templateUrl: './error-screen-signing-summary.component.html',
  styleUrl: './error-screen-signing-summary.component.scss',
})
export class ErrorScreenSigningSummaryComponent {
  private readonly router = inject(Router);

  @Input() errorType: SigningSummaryErrorType;

  handleGoToReport() {
    const url: string = this.router.url;
    const newUrl = url.substring(0, url.lastIndexOf('/'));
    this.navigateTo(newUrl);
  }

  navigateTo(url: string): void {
    window.location.href = url;
  }

  handleRefreshPage() {
    this.reloadPage();
  }

  reloadPage(): void {
    window.location.reload();
  }
}
